module.exports = __webpack_public_path__ + "img/point.21d42e62.png";